import type { LinariaClassName } from '@linaria/core';
import { styled } from '@linaria/react';
import { memo, useCallback } from 'react';
import { avatarUrl } from '../../../mfcLogic/avatarPreviewUrl';
import "./CellImage.linaria.module.css!=!./CellImage?./CellImage.linaria.module.css?css=H4sIAAAAAAAAA9MrNiwuyklLN60uSy0qyUxOzNFNzMlMz7NKyi8pyc+1Ls9MKcmwMjQwULWu5QIA1IAa9S0AAAA="
const StyledCellImage = /*#__PURE__*/styled('img')({
  name: "StyledCellImage",
  class: "s1srlfg5",
  propsAsIs: false
});
interface ICellImage {
  className: LinariaClassName;
  id: string | number;
  slug?: string;
  size?: number;
  onLoad?(): void;
  styleOverrides?: any;
}
const CellImage = memo((props: ICellImage) => {
  const {
    size = 300,
    className,
    onLoad,
    slug,
    id
  } = props;
  const imgSrc = avatarUrl(id, size);
  const handleOnLoad = useCallback(() => {
    onLoad?.();
  }, [onLoad]);
  return <StyledCellImage data-testid="ModelTile__Image" alt={`Enter ${slug}'s Room`} onLoad={handleOnLoad} src={imgSrc} id={`avatar-${id}`} className={className} />;
});
export default CellImage;